export function useDaysFormatter() {
  const daysWeek: { [key: string]: string } = {
    1: 'Lun',
    2: 'Mar',
    3: 'Mer',
    4: 'Jeu',
    5: 'Ven',
    6: 'Sam',
    7: 'Dim'
  }

  const formatDays = (days: string[]): string => {
    const sortedDays = days.map((day) => parseInt(day)).sort((a, b) => a - b)

    const hasConsecutiveDays = (): boolean => {
      return sortedDays.every((day, index) => {
        if (index === 0) return true
        return day === sortedDays[index - 1] + 1
      })
    }
    const isConsecutive = hasConsecutiveDays()

    const resultDay = isConsecutive
      ? `${daysWeek[sortedDays[0]]} - ${daysWeek[sortedDays[sortedDays.length - 1]]}`
      : sortedDays.map((jour) => daysWeek[jour]).join(', ')

    return resultDay
  }

  return {
    formatDays
  }
}
